import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import { Text } from "$components";

type Props = {
  totalUnconform: number;
};

const ConformityRenderer = ({ totalUnconform }: Props) => {
  if (!totalUnconform) {
    return <SentimentSatisfiedAltIcon style={{ color: "green" }} />;
  }
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <SentimentVeryDissatisfiedIcon style={{ color: "tomato" }} />
      &nbsp;
      <Text type="text">
        {`${totalUnconform} non-conforme${totalUnconform > 1 ? "s" : ""}`}
      </Text>
    </div>
  );
};
export default ConformityRenderer;
